import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { MOMENT_DATE_FORMAT } from '@app/_helpers';

@Pipe({
  name: 'istDate'
})
export class IstDatePipe implements PipeTransform {

  /**
   * keeplocaltime is used to specify weather to preserve the time or not.
   * eg : value = 2023-03-03T05:27:20.996000
   * if keeplocaltime is true then  03Mar2023 05:27 AM
   * else withot local 02Mar2023 11:57 PM
   */

  transform(value: unknown, format = MOMENT_DATE_FORMAT, keepLocalTime = false): unknown {
    if (value) {
      return moment(value).utc(keepLocalTime).format(format);
    }
    return value;
  }
}
